import React, { useState, useEffect } from 'react';
import { supabase } from '../db/engine';
import { useApp } from '../context/AppContext';
import SearchSelect from './SearchSelect';
import { fmtFecha } from '../utils/fecha';

// Buscador de póliza por número — gemelo de ClienteSelect pero para pólizas.
// Al escribir solo se filtra el desplegable (número, cliente y vencimiento);
// la lista de la pantalla se filtra recién al SELECCIONAR una póliza.
//
// VARIAS VIGENCIAS DEL MISMO NÚMERO: cuando la aseguradora renueva conservando el
// número hay más de un registro con el mismo `numero`. El desplegable las muestra
// TODAS, agrupadas y de la más reciente a la más vieja, y en esos casos la línea de
// detalle trae el rango de vigencia + estado para poder distinguirlas.
//
// - value / onChange: poliza_id ('' = ninguna). El botón × limpia la selección.
// - width: ancho fijo opcional; sin él ocupa el ancho del contenedor.
// - excludeId: póliza a NO ofrecer. Se usa al vincular la vigencia anterior de una
//   renovación: una póliza no puede renovarse a sí misma (self-reference = error).
export default function PolizaSelect({
  value, onChange, placeholder = 'Filtrar por póliza...', width, excludeId,
}) {
  const { agenteScope, esAgenteRestringido } = useApp();
  const [opciones, setOpciones] = useState([]);

  useEffect(() => {
    let q = supabase.from('polizas')
      .select('id, numero, fecha_inicio, fecha_vencimiento, estado, clientes(nombre)').order('numero');
    if (esAgenteRestringido) q = q.in('id', agenteScope?.polizaIds?.length ? agenteScope.polizaIds : [-1]);
    q.then(({ data }) => {
      const arr = data || [];
      // Cuántas vigencias hay por número (para saber cuáles hay que distinguir)
      const cuantas = {};
      arr.forEach(p => { cuantas[p.numero] = (cuantas[p.numero] || 0) + 1; });
      // Mismo número junto; dentro del número, la vigencia más reciente primero
      const ordenadas = [...arr].sort((a, b) =>
        String(a.numero || '').localeCompare(String(b.numero || ''))
        || String(b.fecha_inicio || '').localeCompare(String(a.fecha_inicio || ''))
        || b.id - a.id);
      setOpciones(ordenadas.map(p => ({
        id: p.id,
        nombre: p.numero,
        meta: [
          p.clientes?.nombre,
          cuantas[p.numero] > 1
            ? `vig. ${fmtFecha(p.fecha_inicio, '?')} → ${fmtFecha(p.fecha_vencimiento, '?')}${p.estado ? ` · ${p.estado}` : ''}`
            : (p.fecha_vencimiento ? `vence ${fmtFecha(p.fecha_vencimiento)}` : null),
        ].filter(Boolean).join(' · '),
      })));
    });
  }, [esAgenteRestringido, agenteScope]);

  const visibles = excludeId
    ? opciones.filter(o => String(o.id) !== String(excludeId))
    : opciones;

  return (
    <div style={width ? { width } : undefined}>
      <SearchSelect
        options={visibles}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
}
